import { _ as _extends } from './extends-a2cb9f0c.esm.js';
import React__default from 'react';
import { useWindowDimensions, View, StyleSheet, Platform, TouchableWithoutFeedback, SafeAreaView, ScrollView } from 'react-native';
import { u as useTheme } from './useTheme-90e8e2c2.esm.js';
import { A as AppAssets } from './index-3256db5b.esm.js';
import { a as AppIcon, A as AppText } from './index-6b88191c.esm.js';

const AppModalHeader = _ref => {
  var _currentTheme$theme;
  let {
    modalTitle,
    isCloseButtonVisible = true,
    barTitleStyle,
    rightIconStyle,
    isLeftButtonVisible,
    onLeftIconPress,
    onRightIconPress,
    leftIconStyle,
    leftIconSize = 20,
    rightIconSize = 20,
    leftIcon = AppAssets.icons.clock,
    headerContainerStyle,
    closeIcon = AppAssets.icons.close,
    isAppIconLeftAvailable = true
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const _style = styleGenerator$1(currentTheme);
  const {
    width
  } = useWindowDimensions();
  return /*#__PURE__*/React__default.createElement(View, {
    style: [_style.headerBar, headerContainerStyle]
  }, isAppIconLeftAvailable && /*#__PURE__*/React__default.createElement(AppIcon, {
    size: leftIconSize,
    isClickable: isLeftButtonVisible,
    onPress: onLeftIconPress,
    icon: leftIcon,
    style: [_style.leftIcon, {
      opacity: isLeftButtonVisible ? 1 : 0
    }, {
      flex: !isLeftButtonVisible && 0
    }, leftIconStyle]
  }), /*#__PURE__*/React__default.createElement(AppText, {
    wrapperStyle: {
      maxWidth: width > 420 ? "90%" : 260
    },
    style: [_style.barTitle, barTitleStyle]
  }, modalTitle), isCloseButtonVisible ? /*#__PURE__*/React__default.createElement(AppIcon, {
    size: rightIconSize,
    isClickable: true,
    onPress: onRightIconPress,
    icon: closeIcon,
    color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.red,
    style: [_style.rightIcon, rightIconStyle]
  }) : /*#__PURE__*/React__default.createElement(View, {
    style: {
      minWidth: 24,
      minHeight: 24
    }
  }));
};
const styleGenerator$1 = props => {
  var _props$theme;
  return StyleSheet.create({
    headerBar: {
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      backgroundColor: "transparent",
      flexDirection: "row",
      paddingTop: 20,
      paddingHorizontal: 20
    },
    barTitle: {
      fontSize: props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.large_font_size,
      fontWeight: "bold",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden"
    },
    rightIcon: {
      position: "absolute",
      top: -28,
      right: -15
    },
    leftIcon: {}
  });
};
AppModalHeader.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppModalHeader",
  "props": {
    "isCloseButtonVisible": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true, the modal top bar shows a clickable icon to the right hand side that allows the modal to close"
    },
    "leftIconSize": {
      "defaultValue": {
        "value": "20",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Size applied to the modal title left icon"
    },
    "rightIconSize": {
      "defaultValue": {
        "value": "20",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Size applied to the modal title right icon"
    },
    "leftIcon": {
      "defaultValue": {
        "value": "assets.icons.clock",
        "computed": true
      },
      "required": false,
      "tsType": {
        "name": "IconDefinition"
      },
      "description": "Style applied to the modal container a level higher than modalStyle"
    },
    "closeIcon": {
      "defaultValue": {
        "value": "assets.icons.close",
        "computed": true
      },
      "required": false,
      "tsType": {
        "name": "IconDefinition"
      },
      "description": "Style applied to the modal title right icon"
    },
    "isAppIconLeftAvailable": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true, an icon to the left hand side of the modal top bar is displayed"
    },
    "modalBackdrop": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true, the modal shows a backdrop behind the core modal view"
    },
    "modalBackdropStatic": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true, the modal shuts down when the user presses outside the view"
    },
    "isModalVisible": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true, the modal becomes visible"
    },
    "closeModal": {
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "() => void",
        "signature": {
          "arguments": [],
          "return": {
            "name": "void"
          }
        }
      },
      "description": "Function to pass to make sure the modal closes as the component is stateless"
    },
    "modalTitle": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Sets the title of the modal view"
    },
    "leftIconStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style applied to the modal title left icon"
    },
    "modalStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style applied to the modal displayed"
    },
    "rightIconStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style applied to the right hand side icon"
    },
    "barTitleStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "/**\nStyle applied to the modal title"
    },
    "headerContainerStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "/**\nStyle applied to the component wrapper"
    },
    "animationType": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Type of animation used when the AppModal gets rendered"
    },
    "onModalViewLayout": {
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "(e) => void",
        "signature": {
          "arguments": [{
            "name": "e"
          }],
          "return": {
            "name": "void"
          }
        }
      },
      "description": "Direct exposure of the onLayout event coming from the react-native View"
    },
    "onRightIconPress": {
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "(e) => void",
        "signature": {
          "arguments": [{
            "name": "e"
          }],
          "return": {
            "name": "void"
          }
        }
      },
      "description": "Direct exposure of the OnPress event coming from the AppIcon on the right"
    },
    "onLeftIconPress": {
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "(e) => void",
        "signature": {
          "arguments": [{
            "name": "e"
          }],
          "return": {
            "name": "void"
          }
        }
      },
      "description": "Direct exposure of the OnPress event coming from the AppIcon on the left"
    },
    "isLeftButtonVisible": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true, the modal top bar shows a clickable icon to the left hand side"
    }
  }
};

const AppModal = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  var _currentTheme$theme, _currentTheme$theme2;
  let {
    modalBackdrop,
    modalBackdropStatic,
    isModalVisible,
    closeModal = () => {},
    modalTitle,
    isCloseButtonVisible,
    modalStyle,
    barTitleStyle,
    modalScrollContainer,
    rightIconStyle,
    leftIconStyle,
    modalWrapperStyle,
    rightIconSize,
    modalInnerContentStyle,
    isAppIconLeftAvailable,
    animationType = "fade",
    onModalViewLayout,
    children,
    transparent,
    headerContainerStyle,
    scrollViewStyle,
    rightWrapperIconStyle,
    ...props
  } = _ref;
  let Modal;
  const {
    currentTheme
  } = useTheme();
  const _style = styleGenerator(currentTheme, modalBackdrop);
  const handleBackdropPress = () => {
    !modalBackdropStatic && closeModal();
  };
  if (Platform.OS !== "web") {
    Modal = require("react-native").Modal;
  } else {
    Modal = require("modal-react-native-web");
  }
  return /*#__PURE__*/React__default.createElement(Modal, _extends({
    animationIn: "slideInUp",
    animationOut: "slideOutDown",
    animationType: animationType,
    hasBackdrop: true,
    ariaHideApp: false,
    backdropColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.grey,
    isVisible: isModalVisible,
    visible: isModalVisible,
    ref: ref,
    transparent: transparent
  }, props), /*#__PURE__*/React__default.createElement(TouchableWithoutFeedback, {
    onPress: handleBackdropPress
  }, /*#__PURE__*/React__default.createElement(View, {
    style: [_style.modalWrapper, modalWrapperStyle]
  }, /*#__PURE__*/React__default.createElement(TouchableWithoutFeedback, null, /*#__PURE__*/React__default.createElement(SafeAreaView, {
    style: [_style.modalContent, modalStyle]
  }, modalTitle ? /*#__PURE__*/React__default.createElement(AppModalHeader, {
    rightIconSize: rightIconSize,
    barTitleStyle: barTitleStyle,
    modalTitle: modalTitle,
    onRightIconPress: closeModal,
    rightIconStyle: rightIconStyle,
    leftIconStyle: leftIconStyle,
    isCloseButtonVisible: isCloseButtonVisible,
    isAppIconLeftAvailable: isAppIconLeftAvailable,
    headerContainerStyle: headerContainerStyle
  }) : isCloseButtonVisible ? /*#__PURE__*/React__default.createElement(AppIcon, {
    size: rightIconSize,
    isClickable: true,
    onPress: closeModal,
    icon: AppAssets.icons.close,
    color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.red,
    wrapperStyle: [rightWrapperIconStyle, {
      position: "absolute",
      right: 20,
      top: 20,
      zIndex: 100
    }]
  }) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null), /*#__PURE__*/React__default.createElement(ScrollView, {
    contentContainerStyle: modalScrollContainer,
    style: [{
      width: "100%"
    }, scrollViewStyle]
  }, /*#__PURE__*/React__default.createElement(View, {
    style: [_style.modalInnerContentStyle, modalInnerContentStyle],
    onLayout: event => {
      var {
        x,
        y,
        width,
        height
      } = event.nativeEvent.layout;
      onModalViewLayout && onModalViewLayout({
        x,
        y,
        width,
        height
      });
    }
  }, children)))))));
});
const styleGenerator = (props, modalBackdrop) => {
  var _props$theme, _props$theme2, _props$theme3;
  return StyleSheet.create({
    modalInnerContentStyle: {
      padding: 10
    },
    modalWrapper: {
      backgroundColor: modalBackdrop ? props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.semi_transparent : "rgba(255, 0, 0, 0)",
      position: "absolute",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    },
    modalContent: {
      justifyContent: "flex-start",
      flexDirection: "column",
      borderRadius: 15,
      alignItems: "center",
      backgroundColor: props === null || props === void 0 ? void 0 : (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.backgroundColor,
      shadowOpacity: 0.3,
      shadowRadius: 4.84,
      shadowColor: props === null || props === void 0 ? void 0 : (_props$theme3 = props.theme) === null || _props$theme3 === void 0 ? void 0 : _props$theme3.shadowColor,
      shadowOffset: {
        width: 3,
        height: 3
      }
    }
  });
};
AppModal.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppModal",
  "props": {
    "closeModal": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "() => void",
        "signature": {
          "arguments": [],
          "return": {
            "name": "void"
          }
        }
      },
      "description": "Function to pass to make sure the modal closes as the component is stateless"
    },
    "animationType": {
      "defaultValue": {
        "value": "\"fade\"",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Type of animation used when the AppModal gets rendered"
    },
    "modalBackdrop": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true, the modal shows a backdrop behind the core modal view"
    },
    "modalBackdropStatic": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true, the modal shuts down when the user presses outside the view"
    },
    "isModalVisible": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true, the modal becomes visible"
    },
    "modalTitle": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Sets the title of the modal view"
    },
    "isCloseButtonVisible": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true, the modal top bar shows a clickable icon to the right hand side that allows the modal to close"
    },
    "modalStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style applied to the modal displayed"
    },
    "barTitleStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style applied to the modal title"
    },
    "rightIconStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style applied to the modal title right icon"
    },
    "leftIconStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style applied to the modal title left icon"
    },
    "modalWrapperStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style applied to the modal container a level higher than modalStyle"
    },
    "rightIconSize": {
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Style applied to the modal title right icon"
    },
    "modalInnerContentStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style applied to the modal inner content"
    },
    "modalScrollContainer": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style applied to the modal scrollView which sits one level above inner content"
    },
    "headerContainerStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style applied to the modal title"
    },
    "isAppIconLeftAvailable": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true, an icon to the left hand side of the modal top bar is displayed"
    },
    "onModalViewLayout": {
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "(e) => void",
        "signature": {
          "arguments": [{
            "name": "e"
          }],
          "return": {
            "name": "void"
          }
        }
      },
      "description": "Direct exposure of the onLayout event coming from the react-native View"
    },
    "scrollViewStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style applied to the modal scrollview"
    },
    "children": {
      "required": false,
      "tsType": {
        "name": "any"
      },
      "description": "Children prop to display content in modal"
    },
    "transparent": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true, the modal does not show backdrop"
    },
    "rightWrapperIconStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": ""
    }
  }
};

export { AppModal as A };
